import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import * as leaseDetailsActions from './../actions/lease-details';
import { LeaseDetails } from '../models/lease-details';
import { LeaseDetailsHttpService } from '../services/lease-details-http.service';
import { switchMap, map, catchError } from 'rxjs';

@Injectable()
export class LeaseDetailsEffects {

  constructor(
    private actions$: Actions,
    private leaseDetailsService: LeaseDetailsHttpService) {
  }

  
  getUnit$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<leaseDetailsActions.Get>(leaseDetailsActions.GET),
    switchMap((action) => {
      return this.leaseDetailsService.getLeaseDetailsByRef(action.leaseRef).pipe(
        map((details: LeaseDetails) => new leaseDetailsActions.GetComplete(details)),
        catchError(err => of(new leaseDetailsActions.GetError(err)))
      );
    })));

}
